import {observer} from 'mobx-react-lite'
import React from 'react'
import tw from 'tailwind-styled-components'
import {Items} from '@api/model/items'
import {multiActionsWithTasksStore} from '@components/multi-actions-with-tasks/multi-actions-with-tasks-store'
import {useGlobalKeyDown} from '@containers/hooks'
import {globals} from '@extensions/globals-base'
import {PageService} from '@extensions/page-service'
import {CollapsedMenu} from './collapsed-menu'
import {useMainMenuStore} from './main-menu-store'
import {BillingMenuItem} from './menu-items/billing-menu-item'
import {ChatsMenuItem} from './menu-items/chats-menu-item'
import {CompanyListMenuItem} from './menu-items/company-list-menu-item'
import {EventFeedMenuItem} from './menu-items/event-feed-menu-item'
import {FeedbackMenuItem} from './menu-items/feedback-menu-item'
import {MyTasksMenuItem} from './menu-items/my-tasks-menu-item'
import {OthersTasksMenuItem} from './menu-items/others-tasks-menu-item'
import {PartnerMenuItem} from './menu-items/partner-menu-item'
import {ProfileMenuItem} from './menu-items/profile-menu-item'
import {ProjectsMenuItem} from './menu-items/projects-menu-item'
import {StatisticsMenuItem} from './menu-items/statistics-menu-item'
import {Banners} from './old-components/banners'
import {Preload} from './old-components/preload'

const TwContainer = tw.div<{$open?: boolean}>`
  ${p => (p.$open ? 'w-240 px-8 pt-8 pb-16' : 'w-48')}
  absolute
  top-0
  left-0
  bottom-0
  text-14
  flex
  flex-col
  bg-panel-background-default
  [backdrop-filter:blur(40px)]
  z-10
  border-solid
  border-0
  border-r-1
  border-panel-line-base
`

export const MainMenuContainer = observer(() => {
  const [state] = useMainMenuStore()
  const {menuOpen} = state
  const multiActionsOff = () => multiActionsWithTasksStore.visibleOff()

  useGlobalKeyDown({
    anyKey: props => {
      const {keyCode, ctrl, meta, shift} = props
      const idx = keyCode - 49
      const companyId = globals.getCompanyId()

      if (idx >= -1 && idx < 9 && shift && (ctrl || meta)) {
        const realIndex = idx === -1 ? 9 : idx
        const projectId = state.projects[realIndex]?.projectId

        if (!projectId) {
          return false
        }

        if (Items.click(Items.get(projectId))) {
          PageService.goToProject(projectId, companyId)
          return true
        }
      }

      return false
    }
  })

  return (
    <div>
      <Preload />
      <TwContainer $open={menuOpen} onClick={multiActionsOff}>
        {menuOpen ? (
          <>
            <ProfileMenuItem />
            <MyTasksMenuItem />
            <OthersTasksMenuItem />

            <ProjectsMenuItem />
            <ChatsMenuItem />

            <EventFeedMenuItem />
            <StatisticsMenuItem />
            <BillingMenuItem />
            <PartnerMenuItem />
            <FeedbackMenuItem />

            <CompanyListMenuItem />

            <Banners />
          </>
        ) : (
          <>
            <CollapsedMenu />
          </>
        )}
      </TwContainer>
    </div>
  )
})
